import { z } from "zod";
import { userIdSchema } from "./userSchema";

/**
 * One `user_activity` row: the user was active in the 15-minute bucket
 * starting at `time` (debug API, docs/client-telemetry.md).
 */
export const userActivitySchema = z
  .object({
    userId: userIdSchema,
    time: z.coerce.date(),
  })
  .meta({ id: "UserActivity" });

export type UserActivity = z.infer<typeof userActivitySchema>;
